<template>
  <div class="chartOption">
  <el-collapse accordion v-if="JSON.stringify(selectObjInfo) != '{}' && JSON.stringify(selectObjOption) != '{}'"
               v-model="activeNames" @change="handleChange"
  style="border: solid;border-width: thin;border-color: #e7e9ee;">
    <el-collapse-item  name="1">
      <template #title>
        <i class="el-icon-menu"></i>
        <span>图表属性</span>
      </template>
      <div class="el-collapse-item-child">
        <el-form
            v-if="optionsData != null"
            ref="form"
            :model="optionsData"
            label-width="80px"
            size="mini"
        >
          <el-form-item label="标题显示">
            <el-switch
                v-model="optionsData.title.style.display"
                active-value="block"
                inactive-value="none"
                @change="
                  (currentValue, oldValue) => {
                    _changeTitle(
                        currentValue,
                        oldValue,
                        { style: { display:  currentValue }}
                    );
                  }"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="图表标题">
            <div class="public-form-item-input">
              <el-input
                  v-model="optionsData.title.text"
                  @change="
                        (currentValue, oldValue) => {
                        _changeTitle(currentValue, oldValue, { text: currentValue});
                        }
                    "
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="标题颜色">
            <div class="public-form-item-colorpicker">
              <el-input
                  v-model="optionsData.title.style.color"
                  :disabled="true"
              ></el-input>
              <el-color-picker
                  show-alpha :predefine="predefineColors"
                  v-model="optionsData.title.style.color"
                  @change="
                        (currentValue, oldValue) => {
                        _changeTitle(currentValue, oldValue, {
                            style: { color: currentValue },
                        });
                        }
                    "
              ></el-color-picker>
            </div>
          </el-form-item>
          <el-form-item label="自算高度">
            <el-switch
                v-model="optionsData.autoChartStyle"
                @change="optionsData.autoChartStyle?_changeChartStyle(optionsData.autoChartStyle): ''"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="图表高度">
            <div class="public-form-item-input">
              <el-input
                  v-model="optionsData.chartContentStyle.height"
                  @blur="_changeChartStyle(optionsData.autoChartStyle)"
                  :disabled="optionsData.autoChartStyle"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="同步缩放">
            <el-switch
                v-model="optionsData.syncScale"
                @change="_changeSyncScale(optionsData.syncScale)"
            >
            </el-switch>
          </el-form-item>
          <el-collapse>
            <el-collapse-item name="1-1" accordion v-model="activeNamesChild" @change="handleChange">
              <template #title>
                <i class="el-icon-paperclip"></i>
                <span>图例</span>
              </template>
              <el-form-item label="图例显示">
                <el-switch
                    v-model="optionsData.legend.enabled"
                    @change="
                  (currentValue, oldValue) => {
                    _changeLegend(
                        currentValue,
                        oldValue,
                        { enabled:  currentValue }
                    );
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="图例浮动">
                <el-switch
                    v-model="optionsData.legend.floating"
                    @change="
                  (currentValue, oldValue) => {
                    _changeLegend(
                        currentValue,
                        oldValue,
                        { floating:  currentValue }
                    );
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="水平位置">
                <div class="public-form-item-input">
                  <el-select
                      v-model="optionsData.legend.align"
                      @change="
                            (currentValue, oldValue) => {
                            _changeLegend(currentValue, oldValue, {
                                align: currentValue,
                            });
                            }
                        "
                  >
                    <el-option
                        v-for="item in align"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="垂直位置">
                <div class="public-form-item-input">
                  <el-select
                      v-model="optionsData.legend.verticalAlign"
                      @change="
                            (currentValue, oldValue) => {
                            _changeLegend(currentValue, oldValue, {
                                verticalAlign: currentValue,
                            });
                            }
                        "
                  >
                    <el-option
                        v-for="item in verticalAlign"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="X偏移">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="optionsData.legend.x"
                      controls-position="right"
                      @change="
                    (currentValue, oldValue) => {
                      _changeLegend(
                          currentValue,
                          oldValue,
                          { x:  currentValue }
                      );
                    }"
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              <el-form-item label="Y偏移">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="optionsData.legend.y"
                      controls-position="right"
                      @change="
                    (currentValue, oldValue) => {
                      _changeLegend(
                          currentValue,
                          oldValue,
                          { y:  currentValue }
                      );
                    }"
                  >
                  </el-input-number>
                </div>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>
    </el-collapse-item>
    <el-collapse-item v-if="selectObjInfo.selectType!='point'" name="2">
      <template #title>
        <i class="el-icon-menu"></i>
        <span>曲线属性</span>
      </template>
      <div class="el-collapse-item-child">
        <el-collapse accordion v-model="activeNamesChild" @change="handleChange">
          <el-collapse-item
              v-for="item in optionsData.series"
              :name="item.id"
              :key="item.id"
              :value="item.id"
          >
            <template #title>
              <i class="el-icon-paperclip"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-form ref="form" :model="item" label-width="80px" size="mini">
              <el-form-item v-if="item.type!='pie' && item.type!='scatter'" label="曲线颜色">
                <div class="public-form-item-colorpicker">
                  <el-input v-model="item.color" :disabled="true"></el-input>
                  <el-color-picker
                      show-alpha :predefine="predefineColors"
                      v-model="item.color"
                      @change="
                  (currentValue, oldValue) => {
                    _changeSeries(
                      currentValue,
                      oldValue,
                      { color: currentValue },
                      item.id
                    );
                  }
                "
                  ></el-color-picker>
                </div>
              </el-form-item>
              <el-form-item v-if="item.type=='column'" label="柱宽度">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.pointWidth"
                      controls-position="right"
                      :min="1"
                      :max="50"
                      @change="
                  (currentValue, oldValue) => {
                    _changeSeries(
                      currentValue,
                      oldValue,
                      { pointWidth: currentValue },
                      item.id
                    );
                  }
                "
                  />
                </div>
              </el-form-item>
              <el-form-item v-else-if="item.type!='pie' && item.type!='scatter'" label="曲线宽度">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.lineWidth"
                      controls-position="right"
                      :min="1"
                      :max="10"
                      @change="
                  (currentValue, oldValue) => {
                    _changeSeries(
                      currentValue,
                      oldValue,
                      { lineWidth: currentValue },
                      item.id
                    );
                  }
                "
                  />
                </div>
              </el-form-item>
              <el-form-item v-if="item.type=='line'  || item.type=='spline'" label="曲线样式">
                <div class="public-form-item-input">
                  <el-select
                      v-model="item.dashStyle"
                      @change="
                    (currentValue, oldValue) => {
                    _changeMarker(
                        currentValue,
                        oldValue,
                        { dashStyle: currentValue },
                        item.id
                    );
                    }
                "
                  >
                    <el-option
                        v-for="item in dashStyleList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item v-if="item.type!='column' && item.type!='pie'  && item.type!='spline' && item.type!='scatter'" label="显示方波">
                <el-switch
                    v-model="item.step"
                    active-value="left"
                    inactive-value=""
                    @change="
                  (currentValue, oldValue) => {
                    _changeSeries(
                        currentValue,
                        oldValue,
                        { step:  currentValue!='left'?'':currentValue },
                        item.id
                    );
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item v-if="item.type=='column' || item.type=='area'" label="叠加类型">
                <!--              item.hasOwnProperty('stacking')-->
                <el-switch
                    v-model="item.stacking"
                    @change="
                        (currentValue, oldValue) => {
                            _changeSeries(currentValue, oldValue, {stacking: currentValue},item.id);
                        }
                    "
                >
                </el-switch>
                <!--              <div class="public-form-item-input">
                                <el-select
                                    v-model="item.stacking"
                                    @change="
                                        (currentValue, oldValue) => {
                                            _changeSeries(currentValue, oldValue, {stacking: currentValue},item.id);
                                        }
                                    "
                                >
                                  <el-option
                                      v-for="item in stacking"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                              </div>-->
              </el-form-item>
              <el-form-item v-if="item.type=='column' || item.type=='area'" label="叠加分组">
                <div class="public-form-item-input">
                  <el-input
                      v-model="item.stack"
                      @change="
                        (currentValue, oldValue) => {
                            _changeSeries(currentValue, oldValue, { stack: currentValue }, item.id);
                        }
                    "
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item v-if="item.type!='column' && item.type!='pie' && item.type!='scatter'" label="显示断点">
                <el-switch
                    v-model="item.breakPointShow"
                    @change="_changeChartStyle(optionsData.autoChartStyle)"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="标签显示">
                <el-switch
                    v-model="item.dataLabels.enabled"
                    @change="
                  (currentValue, oldValue) => {
                    _changeSeries(
                        currentValue,
                        oldValue,
                        { dataLabels: { enabled: currentValue, color: item.dataLabels.color } },
                        item.id
                    );
                    _changeChartStyle(optionsData.autoChartStyle)
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="标签颜色">
                <div class="public-form-item-colorpicker">
                  <el-input v-model="item.dataLabels.color" :disabled="true"></el-input>
                  <el-color-picker
                      show-alpha :predefine="predefineColors"
                      v-model="item.dataLabels.color"
                      @change="
                  (currentValue, oldValue) => {
                    _changeSeries(
                      currentValue,
                      oldValue,
                      { dataLabels: { color: currentValue } },
                      item.id
                    );
                  }
                "
                  ></el-color-picker>
                </div>
              </el-form-item>
              <el-form-item  v-if="item.type!='scatter'" label="标签间隔">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.dataLabelsInterval"
                      :min="1"
                      controls-position="right"
                      @change="_changeChartStyle(optionsData.autoChartStyle)"
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              <el-form-item v-if="item.type=='scatter'" label="点颜色">
                <div class="public-form-item-colorpicker">
                  <el-input v-model="item.color" :disabled="true"></el-input>
                  <el-color-picker
                      show-alpha :predefine="predefineColors"
                      v-model="item.color"
                      @change="
                  (currentValue, oldValue) => {
                    _changeSeries(
                      currentValue,
                      oldValue,
                      { color: currentValue },
                      item.id
                    );
                  }
                "
                  ></el-color-picker>
                </div>
              </el-form-item>
              <el-form-item v-if="item.type!='column' && item.type!='pie' && item.type!='scatter'" label="点显示">
                <el-switch
                    v-model="item.marker.enabled"
                    @change="
                  (currentValue, oldValue) => {
                    _changeSeries(
                        currentValue,
                        oldValue,
                        { marker: { enabled: currentValue} },
                        item.id
                    );
                    _changeChartStyle(optionsData.autoChartStyle)
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item v-if="item.type!='column' && item.type!='pie' && item.type!='scatter'" label="点间隔">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.markerInterval"
                      :min="1"
                      controls-position="right"
                      @change="_changeChartStyle(optionsData.autoChartStyle)"
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              <el-form-item v-if="item.type!='column' && item.type!='pie'" label="点大小">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.marker.radius"
                      controls-position="right"
                      :min="1"
                      :max="10"
                      @change="
                    (currentValue, oldValue) => {
                    _changeMarker(
                        currentValue,
                        oldValue,
                        { marker: { radius: currentValue } },
                        item.id
                    );
                    }
                "
                  />
                </div>
              </el-form-item>
              <el-form-item v-if="item.type!='column' && item.type!='pie'" label="点样式">
                <div class="public-form-item-input">
                  <el-select
                      v-model="item.marker.symbol"
                      @change="
                    (currentValue, oldValue) => {
                    _changeMarker(
                        currentValue,
                        oldValue,
                        { marker: { symbol: currentValue } },
                        item.id
                    );
                    _changeChartStyle(optionsData.autoChartStyle)
                    }
                "
                  >
                    <el-option
                        v-for="item in markerSymbol"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-collapse-item>
    <el-collapse-item v-if="selectObjInfo.selectType=='point'" name="3">
      <template #title>
        <i class="el-icon-menu"></i>
        <span>点属性</span>
      </template>
      <div class="el-collapse-item-child">
        <el-form
            v-if="selectPoint != null"
            ref="form"
            :model="selectPoint"
            label-width="80px"
            size="mini"
        >
          <el-form-item label="名称">
            <div class="public-form-item-input">
              <el-input
                  v-model="selectPoint.name"
                  :disabled="false"
                  @change="
                    (currentValue, oldValue) => {
                      _changePoint(
                        currentValue,
                        oldValue,
                        { 'name': currentValue },
                        optionsData.series[selectObjInfo['seriesIndex']].id,
                        selectPoint.index
                      );
                    }
                  "
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="数据">
            <div class="public-form-item-input">
              <el-input-number
                  v-model="selectPoint.y"
                  @change="
                    (currentValue, oldValue) => {
                      _changePoint(
                        currentValue,
                        oldValue,
                        { y: currentValue },
                        optionsData.series[selectObjInfo['seriesIndex']].id,
                        selectPoint.index
                      );
                    }
                  "
              ></el-input-number>
            </div>
          </el-form-item>
          <el-form-item label="颜色">
            <div class="public-form-item-colorpicker">
              <el-input v-model="selectPoint.color" :disabled="true"></el-input>
              <el-color-picker
                  show-alpha :predefine="predefineColors"
                  v-model="selectPoint.color"
                  @change="
                  (currentValue, oldValue) => {
                    _changePoint(
                      currentValue,
                      oldValue,
                      { 'color': currentValue },
                      optionsData.series[selectObjInfo['seriesIndex']].id,
                      selectPoint.index
                    );
                  }
                "
              ></el-color-picker>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-collapse-item>
    <el-collapse-item  name="4">
      <template #title>
        <i class="el-icon-menu"></i>
        <span>X轴属性</span>
      </template>
      <div class="el-collapse-item-child">
        <el-form
            v-if="optionsData != null"
            ref="form"
            :model="optionsData"
            label-width="80px"
            size="mini"
        >
          <el-form-item label="轴显示">
            <el-switch
                v-model="optionsData.xAxis.visible"
                @change="
                  (currentValue, oldValue) => {
                    _changeXAxis(
                        currentValue,
                        oldValue,
                        { visible:  currentValue }
                    );
                  }"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="值显示">
            <el-switch
                v-model="optionsData.xAxis.labels.enabled"
                @change="
                  (currentValue, oldValue) => {
                    _changeXAxis(
                        currentValue,
                        oldValue,
                        { labels:{ enabled:  currentValue} }
                    );
                  }"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="标题文字">
            <div class="public-form-item-input">
              <el-input
                  v-model="optionsData.xAxis.title.text"
                  @change="
                        (currentValue, oldValue) => {
                        _changeXAxis(currentValue, oldValue, { title:{text: currentValue}});
                        }
                    "
              ></el-input>
            </div>
          </el-form-item>
<!--          <el-form-item label="标题颜色">-->
<!--            <div class="public-form-item-colorpicker">-->
<!--              <el-input-->
<!--                  v-model="optionsData.xAxis.title.style.color"-->
<!--                  :disabled="true"-->
<!--              ></el-input>-->
<!--              <el-color-picker-->
<!--                  v-model="optionsData.xAxis.title.style.color"-->
<!--                  @change="-->
<!--                        (currentValue, oldValue) => {-->
<!--                        _changeXAxis(currentValue, oldValue, {-->
<!--                            title:{style: { color: currentValue }},-->
<!--                        });-->
<!--                        }-->
<!--                    "-->
<!--              ></el-color-picker>-->
<!--            </div>-->
<!--          </el-form-item>-->
          <el-form-item label="标题显示">
            <el-switch
                v-model="optionsData.xAxis.title.enabled"
                @change="
                  (currentValue, oldValue) => {
                    _changeXAxis(
                        currentValue,
                        oldValue,
                        {title:{enabled: currentValue}}
                    );
                  }"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="对向显示">
            <el-switch
                v-model="optionsData.xAxis.opposite"
                @change="
                  (currentValue, oldValue) => {
                    _changeXAxis(
                        currentValue,
                        oldValue,
                        { opposite:  currentValue }
                    );
                  }"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="特定网格">
            <el-switch
                v-model="optionsData.xAxis.isGridLineSpecial"
                @change="_changeChartStyle(optionsData.autoChartStyle)"
            >
            </el-switch>
          </el-form-item>
          <div v-if="optionsData.xAxis.isGridLineSpecial">
            <el-form-item label="网格线宽">
              <div class="public-form-item-input">
                <el-input-number
                    v-model="optionsData.xAxis.gridLineWidthSpecial"
                    :min="0"
                    :max="10"
                    controls-position="right"
                    @change="_changeChartStyle(optionsData.autoChartStyle)"
                >
                </el-input-number>
              </div>
            </el-form-item>
            <el-form-item label="网格颜色">
              <div class="public-form-item-colorpicker">
                <el-input v-model="optionsData.xAxis.gridLineColorSpecial" :disabled="true"></el-input>
                <el-color-picker
                    show-alpha :predefine="predefineColors"
                    v-model="optionsData.xAxis.gridLineColorSpecial"
                    @change="_changeChartStyle(optionsData.autoChartStyle)"
                ></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="网格样式">
              <div class="public-form-item-input">
                <el-select v-model="optionsData.xAxis.gridLineDashStyleSpecial" @change="_changeChartStyle(optionsData.autoChartStyle)">
                  <el-option
                      v-for="item in dashStyleList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="网格线宽">
              <div class="public-form-item-input">
                <el-input-number
                    v-model="optionsData.xAxis.gridLineWidth"
                    :min="0"
                    :max="10"
                    controls-position="right"
                    @change="
                            (currentValue, oldValue) => {
                            _changeXAxis(currentValue, oldValue, {
                                gridLineWidth: currentValue,
                            });
                            }
                        "
                >
                </el-input-number>
              </div>
            </el-form-item>
            <el-form-item label="网格颜色">
              <div class="public-form-item-colorpicker">
                <el-input
                    v-model="optionsData.xAxis.gridLineColor"
                    :disabled="true"
                ></el-input>
                <el-color-picker
                    show-alpha :predefine="predefineColors"
                    v-model="optionsData.xAxis.gridLineColor"
                    @change="
                            (currentValue, oldValue) => {
                            _changeXAxis(currentValue, oldValue, {
                                gridLineColor: currentValue,
                            });
                            }
                        "
                ></el-color-picker>
              </div>
            </el-form-item>
            <el-form-item label="网格样式">
              <div class="public-form-item-input">
                <el-select
                    v-model="optionsData.xAxis.gridLineDashStyle"
                    @change="
                            (currentValue, oldValue) => {
                            _changeXAxis(currentValue, oldValue, {
                                gridLineDashStyle: currentValue,
                            });
                            }
                        "
                >
                  <el-option
                      v-for="item in dashStyleList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>
          <div v-if="optionsData.xAxis.xAxisType == '数值'">
            <el-form-item label="最小值">
              <div class="public-form-item-input">
                <el-input-number
                    v-model="optionsData.xAxis.minNumber"
                    controls-position="right"
                    @change="_changexAisxTick(optionsData.xAxis)"
                >
                </el-input-number>
              </div>
            </el-form-item>
            <el-form-item label="标签间隔">
              <div class="public-form-item-input">
                <el-input-number
                    v-model="optionsData.xAxis.tickIntervalNumber"
                    :min="0"
                    controls-position="right"
                    @change="_changexAisxTick(optionsData.xAxis)"
                >
                </el-input-number>
              </div>
            </el-form-item>
            <el-form-item label="标签个数">
              <div class="public-form-item-input">
                <el-input-number
                    v-model="optionsData.xAxis.tickAmountNumber"
                    :min="2"
                    controls-position="right"
                    @change="_changexAisxTick(optionsData.xAxis)"
                >
                </el-input-number>
              </div>
            </el-form-item>
          </div>
          <el-form-item v-else label="标签间隔">
            <div class="public-form-item-input">
              <el-input-number
                  v-model="optionsData.xAxis.tickInterval"
                  :min="0"
                  :max="1000"
                  controls-position="right"
                  @change="
                            (currentValue, oldValue) => {
                            _changeXAxis(currentValue, oldValue, {
                                tickInterval: currentValue,
                            });
                            }
                        "
              >
              </el-input-number>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-collapse-item>
    <el-collapse-item v-if="selectObjInfo.selectType!='point'" name="5">
      <template #title>
        <i class="el-icon-menu"></i>
        <span>Y轴属性</span>
      </template>
      <div class="el-collapse-item-child">
        <el-collapse accordion v-model="activeNamesChild" @change="handleChange">
          <el-collapse-item
              v-for="item in optionsData.yAxis"
              :name="item.id"
              :key="item.id"
              :value="item.id"
          >
            <template #title>
              <i class="el-icon-paperclip"></i>
              <span>{{ item.title.text }}</span>
            </template>
            <el-form ref="form" :model="item" label-width="80px" size="mini">
              <el-form-item label="轴显示">
                <el-switch
                    v-model="item.visible"
                    @change="
                  (currentValue, oldValue) => {
                    _changeYAxis(
                        currentValue,
                        oldValue,
                        { visible:  currentValue },
                        item.id
                    );
                    _changeChartStyle(optionsData.autoChartStyle)
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="标题显示">
                <el-switch
                    v-model="item.title.enabled"
                    @change="
                  (currentValue, oldValue) => {
                    _changeYAxis(
                        currentValue,
                        oldValue,
                        {title:{enabled: currentValue}},
                        item.id
                    );
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="标题文字">
                <div class="public-form-item-input">
                  <el-input
                      v-model="item.title.text"
                      @change="
                        (currentValue, oldValue) => {
                        _changeYAxis(
                            currentValue,
                            oldValue,
                            { title:{text: currentValue}},
                            item.id
                            );
                        }
                    "
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item label="对向显示">
                <el-switch
                    v-model="item.opposite"
                    @change="
                  (currentValue, oldValue) => {
                    _changeYAxis(
                        currentValue,
                        oldValue,
                        { opposite:  currentValue },
                        item.id
                    );
                    _changeChartStyle(optionsData.autoChartStyle)
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="刻度翻转">
                <el-switch
                    v-model="item.reversed"
                    @change="
                  (currentValue, oldValue) => {
                    _changeYAxis(
                        currentValue,
                        oldValue,
                        { reversed:  currentValue },
                        item.id
                    );
                  }"
                >
                </el-switch>
              </el-form-item>
              <el-form-item label="网格线宽">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.gridLineWidth"
                      :min="0"
                      :max="10"
                      controls-position="right"
                      @change="
                        (currentValue, oldValue) => {
                            _changeYAxis(
                                currentValue,
                                oldValue,
                                {gridLineWidth: currentValue},
                                item.id
                            );
                        }
                    "
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              <el-form-item label="固定标签">
                <el-switch
                    v-model="item.customTick"
                    @change="_changeChartStyle(optionsData.autoChartStyle)"
                >
                </el-switch>
              </el-form-item>
              <span v-if="item.customTick">
                <el-form-item label="标签个数">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.tickNumber"
                      @change="_changeChartStyle(optionsData.autoChartStyle)"
                      :min="1"
                      controls-position="right"
                  >
                  </el-input-number>
                </div>
              </el-form-item>
                <el-form-item label="最大值">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.tickMax"
                      @change="_changeChartStyle(optionsData.autoChartStyle)"
                      controls-position="right"
                  >
                  </el-input-number>
                </div>
              </el-form-item>
                <el-form-item label="最小值">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.tickmin"
                      @change="_changeChartStyle(optionsData.autoChartStyle)"
                      controls-position="right"
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              </span>
              <span v-else>
                <el-form-item label="标签个数">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.tickAmount"
                      :min="2"
                      controls-position="right"
                      @change="
                        (currentValue, oldValue) => {
                          _changeYAxis(
                              currentValue,
                              oldValue,
                              { tickAmount: currentValue },
                              item.id
                           );
                        }
                    "
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              <el-form-item label="标签间隔">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.tickInterval"
                      :min="0"
                      controls-position="right"
                      @change="
                        (currentValue, oldValue) => {
                          _changeYAxis(
                              currentValue,
                              oldValue,
                              { tickInterval: currentValue },
                              item.id
                           );
                        }
                    "
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              <el-form-item label="最大值">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.max"
                      controls-position="right"
                      @change="
                        (currentValue, oldValue) => {
                          _changeYAxis(
                              currentValue,
                              oldValue,
                              { max: currentValue },
                              item.id
                           );
                        }
                    "
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              <el-form-item label="最小值">
                <div class="public-form-item-input">
                  <el-input-number
                      v-model="item.min"
                      controls-position="right"
                      @change="
                        (currentValue, oldValue) => {
                          _changeYAxis(
                              currentValue,
                              oldValue,
                              { min: currentValue },
                              item.id
                           );
                        }
                    "
                  >
                  </el-input-number>
                </div>
              </el-form-item>
              </span>

            </el-form>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-collapse-item>
  </el-collapse>
  </div>
</template>

<script>
import eventInsim from "../event.js";
// import { Edit } from '@element-plus/icons'

export default {
  // 验证类型
  props: ["selectObjOption", "selectObjInfo"],
  watch: {
    //选中对象对应配置
    selectObjOption: {
      type: Object,
      default: () => ({}),
      handler: function () {
        console.log("selectObjOption(watch)", "selectObjOption", this.selectObjOption);
      },
    },
    //选择对象参数(选中对象类型是图表、曲线或者点，chart index，series index， point index )
    selectObjInfo:{
      type: Object,
      default: () => ({}),
      handler: function () {
        this.selectPoint = 'point' in this.selectObjInfo ? this.selectObjInfo['point'] : null;
        this.optionsData = this.selectObjOption;

        console.log("selectObjInfo(watch)", "selectObjInfo", this.selectObjInfo);
      },
    }
  },
  data() {
    return {
      activeNames: this.$store.state.activeNames,//折叠模板展开项
      activeNamesChild: this.$store.state.activeNamesChild,//折叠子面板展开项
      align: [
        {
          value: 'left',
          label: "左",
        },
        {
          value: 'center',
          label: "中",
        },
        {
          value: 'right',
          label: "右",
        }
      ],
      verticalAlign: [
        {
          value: 'top',
          label: "上",
        },
        // {
        //   value: 'middle',
        //   label: "中",
        // },
        {
          value: 'bottom',
          label: "下",
        }
      ],
/*      stacking: [
        {
          value: 'normal',
          label: "normal",
        },
        {
          value: 'percent',
          label: "percent",
        },
        {
          value: '',
          label: "not stack",
        }
      ],*/
      markerSymbol: [
        {
          value: "circle",
          label: "○",
        },
        {
          value: "triangle",
          label: "△",
        },
        {
          value: "triangle-down",
          label: "▽",
        },
        {
          value: "diamond",
          label: "◇",
        },
        {
          value: "square",
          label: "□",
        },
      ],
      optionsData: this.selectObjOption,
      selectPoint: null,
      // optionsData: {}
      dashStyleList:[
        {
          value: "Solid",
          label: "实线",
        },
        {
          value: "Dash",
          label: "短虚线",
        },
        {
          value: "LongDash",
          label: "长虚线",
        },
        {
          value: "Dot",
          label: "点虚线",
        },
      ],//曲线样式列表
      predefineColors : ["#ffffff","#000000","#e7e6e6","#44546a","#5b9bd5","#ed7d31","#a5a5a5","#ffc000",
        "#4472c4","#70ad47","#7f7f7f","#0c0c0c","#171616","#222a35","#1e4e79","#833c0b","#525252",
        "#7f6000","#1f3864","#375623","#c00000","#ff0000","#ffc000","#ffff00","#92d050","#00b050",
        "#00b0f0","#0070c0","#002060","#7030a0"],//颜色板常用颜色设置
    };
  },
  methods: {
    _changeSeries(currentValue, oldValue, option, id) {
      console.log("change",option,id)
      eventInsim.emit("seriesOptionChange", {option: option, id: id});
    },
    _changeMarker(currentValue, oldValue, option, id) {
      eventInsim.emit("seriesMarkerOptionChange", {option: option, id: id});
    },
    _changeLegend(currentValue, oldValue, option) {
      eventInsim.emit("legendOptionChange", {option: option});
    },
    _changeTitle(currentValue, oldValue, option) {
      eventInsim.emit("titleOptionChange", {option: option});
    },
    _changePoint(currentValue, oldValue, option, seriesId, pointIndex) {
      eventInsim.emit("pointOptionChange", {option: option, seriesId: seriesId, pointIndex: pointIndex});
    },
    _changeXAxis(currentValue, oldValue, option) {
      eventInsim.emit("xAxisOptionChange", {option: option});
    },
    _changeYAxis(currentValue, oldValue, option, yAxisId) {
      eventInsim.emit("yAxisOptionChange", {option: option, yAxisId: yAxisId});
    },
    //记录点击标签
    handleChange() {
      console.log(this.activeNames,this.activeNamesChild);
      this.$store.state.activeNames=this.activeNames;
      this.$store.state.activeNamesChild=this.activeNamesChild;
    },
    //自动计算高度修改触发
    _changeChartStyle(value){
      this.$emit("reflashView-event",value);
    },
    //同步缩放修改触发
    _changeSyncScale(value){
      this.$emit("changeSyncScale",value);
    },
    //x轴标签修改触发
    _changexAisxTick(value){
      this.$emit("changexAisxTick",value);
    },
  },
};
</script>
<style lang="less">
@box-width: 150px;
.chartOption .public-form-item-input {
  position: relative;
  width: @box-width;

  .el-input {
    width: @box-width;
  }

  .el-input-number {
    width: @box-width;
  }

  .el-select {
    width: @box-width;
  }

  .el-input {
    width: @box-width;
  }
}

.chartOption .public-form-item-colorpicker {
  position: relative;
  width: @box-width;

  .el-icon-arrow-down {
    display: none !important;
  }

  .el-color-picker {
    position: absolute;
    right: 0;

    .el-color-picker__trigger {
      border: 0;
      width: 80px;
    }
  }
}

.chartOption .el-collapse {
  .el-collapse-item {
    .el-collapse-item__header {
      //background-color: #b3cdf0;
      //background-color: #409EFC;
      //color: #fff;
      height: 35px;
      padding-left: 10px;
    }

    .el-collapse-item__wrap {
      //overflow: auto;
      //background-color: #eeefeb;

      .el-collapse-item__content {
        padding-bottom: 0;
        // background: rgb(246, 246, 246);
      }
    }

    .el-collapse-item-child {
      .el-collapse-item__header {
        padding-left: 10px;
        //background-color: #e1e3e4;
        background-color: #fff;
      }

    }
  }
}

.chartOption .el-form {
  .el-form-item--mini.el-form-item {
    margin-bottom: 1px;
  }
}


</style>